import { apiClient } from "api/client";

export async function getPointListApi(id) {
  const { data } = await apiClient.get("/get/point", { params: { id } });
  return Array.isArray(data) ? data : [];
}

export async function getPointCountApi(id) {
  const { data } = await apiClient.get("/get/point/count", { params: { id } });
  if (typeof data === "number") return data;
  if (data && typeof data.count === "number") return data.count;
  return 0;
}
